export const REDIRECTS = {
  'mejores-depositos':
    'https://www.finect.com/usuario/eduardogarcia/articulos/los-mejores-depositos-bancarios-a-plazo-fijo'
};

export const aliasNoAds = ['Finect Brands'];
export const aliasWithAds = ['finect-talks'];
export const aliasWithTagContent = ['finect-alpha', 'finect-talks', 'finect', 'outlook'];
